import React, { FC } from 'react';
import { Routes } from './Routes';

const App: FC = () => <Routes />;

export default App;
